/** 路由路径常量（叶子模块，避免经 routerConfig 拉起整棵路由树） */
export const LOGIN_PATH = '/login';
